type StyleProvider = (provided: any) => any;
type StylesMap = Record<string, StyleProvider>;

export function getCustomStylesErro(props: { classeCss?: string }): StylesMap {
	return {
		control: (provided: any) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid red",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided: any) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided: any) => ({
			...provided,
			width: "max-content",
			minWidth: props?.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided: any) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided: any) => ({
			...provided,
			fontSize: "13px",
		}),
	};
}

export function getEstiloRota(props: { classeCss?: string }): StylesMap {
	return {
		control: (provided: any) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided: any) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided: any) => ({
			...provided,
			width: "max-content",
			minWidth: props?.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided: any) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided: any) => ({
			...provided,
			fontSize: "13px",
		}),
	};
}

export function mapOpcoesRota<T extends { nome?: string }>(
	listaRotas?: T[],
): Array<T & { value: string; label: string }> {
	if (!Array.isArray(listaRotas)) return [];
	return listaRotas.map((data) => ({
		...(data as T),
		value: data.nome ?? "",
		label: data.nome ?? "",
	}));
}
